import React from "react";
import PropTypes from "prop-types";
import { JsonPreview, JsonValidator } from "@dtsl/react-utils";
function JsonViewer(_ref) {
  let {
    data,
    hideRoot,
    getItemString,
    getValueRenderer,
    getlLabelRenderer,
    collectionLimit,
    initiallyExpandedLevel,
    previewContainerClassName,
    rootLabel,
    validatorContainerClassName,
    getValidationErrorContent,
    errorColumnClassName
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(JsonValidator, {
    data: data,
    getValidationErrorContent: getValidationErrorContent,
    validatorContainerClassName: validatorContainerClassName,
    errorColumnClassName: errorColumnClassName
  }), /*#__PURE__*/React.createElement(JsonPreview, {
    data: data,
    hideRoot: hideRoot,
    collectionLimit: collectionLimit,
    initiallyExpandedLevel: initiallyExpandedLevel,
    previewContainerClassName: previewContainerClassName,
    rootLabel: rootLabel,
    getItemString: getItemString,
    getValueRenderer: getValueRenderer,
    getlLabelRenderer: getlLabelRenderer
  }));
}
JsonViewer.propTypes = {
  data: PropTypes.string,
  initiallyExpandedLevel: PropTypes.number,
  hideRoot: PropTypes.bool,
  collectionLimit: PropTypes.number,
  previewContainerClassName: PropTypes.object,
  rootLabel: PropTypes.string,
  getValidationErrorContent: PropTypes.func,
  validatorContainerClassName: PropTypes.object,
  errorColumnClassName: PropTypes.object,
  getItemString: PropTypes.func,
  getValueRenderer: PropTypes.func,
  getlLabelRenderer: PropTypes.func
};
export { JsonViewer };